<div class="cart-furnisher">
  <cx-accordion id="cart-items" [isActive]="(accordionState$ | async)?.get('cart-items') ?? true" [onClick]="onAccordionClick">
    <div class="furnisher-title" accordionTitle>
      <span>Itens do carrinho</span>
    </div>

    <div class="b2b-unit-content">
      @for (entry of entries$ | async; track $index) {
        <cart-product [entry]="entry" [disabled]="disabledItems" [onCheckout]="onCheckout" />
      }
    </div>
  </cx-accordion>
</div>
